import { render, staticRenderFns } from "./VServicesTemplate.vue?vue&type=template&id=26dd8b7c&scoped=true&lang=pug"
import script from "./VServicesTemplate.vue?vue&type=script&lang=ts"
export * from "./VServicesTemplate.vue?vue&type=script&lang=ts"
import style0 from "./VServicesTemplate.vue?vue&type=style&index=0&id=26dd8b7c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26dd8b7c",
  null
  
)

/* custom blocks */
import block0 from "./RServicesTemplate.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Frunner%2Fwork%2Fcompliance-nationbetter-uk%2Fcompliance-nationbetter-uk%2Fsrc%2Fmodules%2FServices%2FTemplate%2FVServicesTemplate.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports